<!-- 门店类型 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal"
                    >新增门店类型</Button
                >
                <Table
                    ref="selection"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                    @on-selection-change="changeSelection"
                >
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goModal(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox
                        class="checkbox-ml"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <span class="mr24 ml24"
                        >已经选择{{ delData.length }}个</span
                    >
                    <Button type="error" ghost @click="goDel(0)">删除</Button>
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formData"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="门店类型:">
                        <Input
                            type="text"
                            v-model="formData.name"
                            placeholder="请输入门店类型"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    store_type_list,
    store_type_save,
    store_type_delete,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "类型", key: "name", align: "center" },
                { title: "门店数量", key: "store_count", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            formData: {
                id: "",
                name: "",
            },
            modals: false,
            modalTitle: "",
            // selection
            del_id: "",
            delData: [],
            del_value: false,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            store_type_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 确定
        submitModal() {
            store_type_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        goModal(row) {
            if (row.id) {
                this.modalTitle = "编辑门店类型";
                this.formData.id = row.id;
                this.formData.name = row.name;
            } else {
                this.modalTitle = "新增门店类型";
                this.formData.id = "";
                this.formData.name = "";
            }
            this.modals = true;
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        store_type_delete({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    } else if (index == 1) {
                        store_type_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((err) => {
                                this.$Message.error(err.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
    },
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.checkbox-ml {
    margin-left: 20px !important;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-form-item {
    margin-bottom: 0 !important;
}
</style>